export default {
    title: "Articoli non consegnati",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Grazie",
        message: "Grazie per la risposta."
    },
    message: "Hai indicato di non aver ricevuto l'articolo nonostante il corriere lo abbia contrassegnato come consegnato.",
    cta: "Per aiutarci a risolvere il problema, segui questi passaggi:",
    items: {
        1: {
            message: "Fare clic sui link di tracciamento:"
        },
        2: {
            message: "Controlla lo stato della consegna. Controlla:",
            items: {
                1: "Chi ha firmato per il pacco?",
                2: "Se è stato restituito al mittente",
                3: "Se il pacco è in attesa di ritiro"
            }
        },
        3: {
            message: "Controllare la presenza di un avviso di consegna che indichi dove potrebbe essere stato lasciato l'articolo."
        },
        4: {
            message: "Verifica con vicini, parenti e amici che potrebbero aver preso il pacco."
        }
    },
    question: "Questo ti ha aiutato a risolvere il tuo problema di consegna? Ora possiedi l'articolo o sai chi lo possiede? Rispondi qui sotto.",
    product: {
        name: "Nome dell'articolo",
        quantity: "Quantità",
        tracking: "Monitoraggio",
    },
    buttons: {
        yes: "SÌ",
        no: "NO",
        saving: "Risparmio"
    }
}